import { render, staticRenderFns } from "./detach.vue?vue&type=template&id=fe384de6&scoped=true&"
import script from "./detach.vue?vue&type=script&lang=js&"
export * from "./detach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe384de6",
  null
  
)

export default component.exports